module.exports = __webpack_public_path__ + "media/empty-states/signatures-2x-898d8fe7.png";